<template>
    <div class="container login-box">
        <div class="row">
            <div class="col-10 offset-1 col-md-6 offset-md-3 section">
                <h1>Reset Password</h1>
                <p>Please confirm your new password.</p>
                <br />
                <form @submit.prevent="reset" method="POST" action="" class="form">
                    <div class="form-group">
                        <input v-model="new_password" name="new_password" placeholder="Enter Password" class="form-control" type="password" />
                    </div>

                    <div class="form-group">
                        <input v-model="new_password_confirm" name="new_password_confirm" placeholder="Repeat Password" class="form-control" type="password" />
                    </div>


                    <div class="form-group">
                        <button class="btn btn-primary">Submit</button>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-10 offset-1 col-md-6 offset-md-3 section-blank">
                <router-link to="/login">Back to Login</router-link>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
    const LOGIN_URL = 'login';

    export default {

        data() {
            return {
                username: '',
                new_password: '',
                new_password_confirm: '',
                redirect: ''
            }
        },

        created(){
            console.log(this.$route.params.hash);
            /*
             if(this.$store.getters.checkAuth){
             var redirect = this.redirect || '/';
             this.$router.push(redirect);
             }
             */
        },

        methods:{
            reset(){
                var _this = this;
                this.$store.commit('setStatus', {
                    status: null,
                    message:null
                });

                this.$send(this, 'userPasswordUpdate', {
                    new_password: this.new_password,
                    new_password_confirm: this.new_password_confirm,
                    password_reset_token: this.$route.params.hash
                }).finally(() => {
                    _this.new_password = null;
                    _this.new_password_confirm = null;
                });


//                this.$http.post('http://10.0.24.14/api.php', {
//                    function: 'userPasswordUpdate',
//                    data: {
//                        new_password: this.new_password,
//                        new_password_confirm: this.new_password_confirm,
//                        password_reset_token: this.$route.params.hash
//                    }
//                }, {
//                    emulateJSON: true
//                }).then(function(response){
//                    _this.new_password = null;
//                    _this.new_password_confirm = null;
//                    if(response.body.status){
//                        this.$store.commit('setStatus', {
//                            status: true,
//                            message:response.body.message
//                        });
//
//                    } else {
//                        this.$store.commit('setStatus', {
//                            status: false,
//                            message:response.body.message
//                        });
//                    }
//                });
            }
        }
    }

</script>
<style>
    h1{
        font-size: 16px;
    }
    .login-box{
        margin-top: 150px;
    }

</style>



// WEBPACK FOOTER //
// PasswordResetConfirmation.vue?159af95f